// extracted by mini-css-extract-plugin
module.exports = {"tableHighlightWrapper":"OAGPT","tableHighlightColumn":"o6sEW","tableHighlightRow":"_26i+G"};